// TagsInput.vue
<template>
  <div class="muli-tags" @click="focus">
    <el-tag
      style="margin-left:5px;margin-top:5px;margin-right:5px;"
      v-for="(tag,index) in tags"
      :key="index"
      closable
      @close="delTag(index)"
      :type="tag.type"
    >{{tag}}</el-tag>

    <input
      type="text"
      ref="input"
      class="inputTags"
      :placeholder="tags.length> 0?'':placeholder"
      style="width:370px;margin-left:10px;"
      :disabled="disabled"
      @keyup.enter="add"
      @keydown.delete="del"
      @keydown.186="split"
      v-model="current"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    split(e) {
      e.preventDefault()
      this.add(e)
    },
    add(e) {
      const val = e.target.value
      if (!val) return
      if (this.tags.indexOf(val) > -1) {
        this.$message.error('该序列号已存在！')
        return
      }
      if (!this.disabled) {
        this.tags.push(val)
      }
      this.$emit('input', this.tags)
      this.current = ''
    },
    del(e) {
      if (!e.target.value.length) {
        if (!this.disabled) {
          this.tags.pop()
        }
        this.$emit('input', this.tags)
      }
    },
    delTag(index) {
      if (!this.disabled) {
        this.tags.splice(index, 1)
      }
      this.$emit('input', this.tags)
    }
  },
  computed: {
    tags() {
      return this.value.slice()
    }
  },
  data() {
    return {
      placeholder: '输入产品序列号，多个序列号可以回车或用英文分号（;）隔开',
      current: ''
    }
  }
}
</script>

<style lang='less'>
.muli-tags {
  height: 120px;
  overflow: auto;
  padding: 5px 10px;
  margin-left: 30px;
  display: block;
  border: 1px solid #ccc;
  input {
    background: transparent;
    border: none;
  }

  input {
    outline: none;
  }
  .btn {
    margin: 0 5px 3px 0;
    padding: 4px 5px;
    background: #fff;
    border: 1px solid #eee;
    box-shadow: 0 0 4px;
  }
}
</style>
